let primaryApi = {};
/* 为了方便调用，把乐园和小游戏方法相近的改为统一名称(以乐园为准) */
//233小游戏相关api
const androidApi = {
	/* 判断运行环境 sg-233小游戏 pd-233乐园 */
	isSource: 'sg',
	/* 是否已下载内/外部游戏 */
	isDownloaded: (packageName) => {
		return Android.isDownloaded(packageName);
	},
	/* 外部是否安装此游戏 */
	isInstallOuterApp: (packageName) => {
		return Android.isInstalledPkg(packageName); //内/外部是否安装此游戏
	},
	/* 内部是否安装此游戏 */
	isGameInstall: (packageName) => {
		return Android.isInstalledPkg(packageName); //内/外部是否安装此游戏
	},
	/* 下载内/外部游戏 */
	downloadGame: (gameInf) => {
		Android.downloadApkByPkg(gameInf.packageName);
	},
	/* 暂停下载内/外部游戏 */
	downloadStop: (gameInf) => {
		Android.stopDownload(gameInf.packageName);
	},
	/* 安装内/外部游戏 */
	installApk: (packageName) => {
		Android.installApk(packageName);
	},
	/* 拉起外部游戏 */
	openOuterAppByPackage: (packageName) => {
		Android.openApp(packageName);
	},
	/* 拉起内部游戏 */
	playGame: (gameInf) => {
		Android.playGame(gameInf.packageName);
	},
	/* 分享 */
	share: (shareInfo) => {//shareType Int 微信 0x1，微信朋友圈 0x2，QQ 0x3，QQ空间 0x4
		switch (shareInfo.shareType) {
			case 0x1:
				Android.shareWebByType(1, shareInfo.title, shareInfo.desc, shareInfo.imgUrl, shareInfo.targetUrl, shareInfo.analyticsType, shareInfo.title, shareInfo.desc, '', true, -1, -1);
				return true;
			case 0x2:
				Android.shareWebByWeChatMoment(1, shareInfo.title, shareInfo.desc, shareInfo.imgUrl, shareInfo.targetUrl, shareInfo.analyticsType, '',-1,-1);
				return true;
			case 0x3:
				Android.shareWebByQQ(1, shareInfo.title, shareInfo.desc, shareInfo.imgUrl, shareInfo.targetUrl, shareInfo.analyticsType, shareInfo.title, shareInfo.desc, '',-1,-1);
				return true;
			case 0x4:
				Android.shareWebByQQZone(1,  shareInfo.title, shareInfo.desc, shareInfo.imgUrl, shareInfo.targetUrl, shareInfo.analyticsType, shareInfo.title, shareInfo.desc, '',-1,-1);
				return true;
		}
	},
	/* 获取用户信息 */
	getUserInfo: () => {
		return Android.getUserInfo();
	},
	/* 复制到剪贴板 */
	writeClipBoard: (text) => {
		Android.copyCampaignWebText(text);
	},
	/* 获取游戏时长 */
	getAppUsageDuration: (packageName, beginTime, endTime) => {
		Android.fetchPkgPlayTime(beginTime, endTime, packageName);
	},
	/* 是否有查看app使用时长权限 */
	hasAppUsagePermission: () => { //小游戏暂不做判断,默认有授权
		return true;
	},
	/* 获取233版本号 */
	getAppVersionCode: () => {
		return Android.getAppVersionCode();
	},
	/* 获取233版本名称 */
	getAppVersionName: () => {
		return Android.getAppVersionName();
	},
	/* 获取233渠道名 */
	getAppChannel: () => {
		return Android.getAppChannel();
	},
	/* 播放广告 */
	playADVideo: () => {
		Android.campaignShowAdVideo()
	},
	/* 跳转web-url */
	openNativeWeb: (title, param) => {
		window.location.href = param;
	},
}

//233乐园相关api
const metaXApi = {
	/* 判断运行环境 sg-233小游戏 pd-233乐园 */
	isSource: 'pd',
	/* 233乐园的调用都使用这个方法 */
	callMetaX: (method, callback, ...params) => {
		var obj = {};
		obj.method = method;
		obj.asyncCallback = callback || ''; //指定回调函数
		obj.param = params;
		let resData = JSON.parse(MetaX.exec(JSON.stringify(obj)));
		return resData;
	},
	/* 外部是否安装此游戏 */
	isInstallOuterApp: (packageName) => {
		let res = metaXApi.callMetaX('isInstallOuterApp', '', packageName);
		if (res.code == 200 && res.data == 'true') { //"code":200成功,"code":404不支持的方法,"code":500异常方法,"code":302异步,
			return true;
		} else {
			return false;
		}
	},
	/* 拉起外部游戏 */
	openOuterAppByPackage: (packageName) => {
		metaXApi.callMetaX('openOuterAppByPackage', '', packageName);
	},
	/* 内/外部下载并安装游戏 */
	downloadGame: (gameInf, progress) => {
		metaXApi.callMetaX('downloadGame', '', progress.toString(), JSON.stringify(gameInf));
	},
	/* 暂停下载内/外部游戏 */
	downloadStop: (gameInf) => {
		metaXApi.callMetaX('downloadStop', '', JSON.stringify(gameInf));
	},
	/* 内部是否安装此游戏 */
	isGameInstall: (packageName) => {
		let res = metaXApi.callMetaX('isGameInstall', '', packageName);
		if (res.code == 200 && res.data == 'true') { //"code":200成功,"code":404不支持的方法,"code":500异常方法,"code":302异步,
			return true;
		} else {
			return false;
		}
	},
	/* 拉起内部游戏 */
	playGame: (gameInf) => {
		metaXApi.callMetaX('playGame', '', JSON.stringify(gameInf));
	},
	/* 分享 */
	share: (shareInfo) => {
		let shareData = {
			//分享网页4个参数
			targetUrl: shareInfo.targetUrl, //分享链接
			title: shareInfo.title, //分享标题
			desc: shareInfo.desc, //分享描述
			imgUrl: shareInfo.imgUrl, //分享图标
			isWeb: shareInfo.isWeb, //是否由web端创建对话框
			shareType: shareInfo.shareType, //Int 微信 0x1，微信朋友圈 0x2，QQ 0x3，QQ空间 0x4
			shareStyle: shareInfo.shareStyle, //落地分享展现方式, 只分享文字 0xB,微信网页 0x15,微信朋友圈分享网页 0x16,qq分享网页 0x1f,qq空间分享网页 0x20
			locationId: shareInfo.locationId, //Int 功能ID
			relationship: shareInfo.relationship, //Int 关系（3:游戏分享）
			relationshipExtra: shareInfo.relationshipExtra, //Long关系参数（3：gameId） string
			pos: shareInfo.pos, //Int APP进入位置
			posExtra: shareInfo.posExtra //Long APP进入位置参数
		}
		let res = metaXApi.callMetaX('share', '', JSON.stringify(shareData));
		if (res.code == 200) { //"code":200成功,"code":404不支持的方法,"code":500异常方法,"code":302异步,
			return true;
		} else {
			return false;
		}
	},
	/* 获取用户信息 */
	getUserInfo: () => {
		let res = metaXApi.callMetaX('getUserInfo', '');
		if (res.code == 200) { //"code":200成功,"code":404不支持的方法,"code":500异常方法,"code":302异步,
			return res.data;
		} else {
			return false;
		}
	},
	/* 复制到剪贴板 */
	writeClipBoard: (text) => {
		metaXApi.callMetaX('writeClipBoard', '', text);
	},
	/* 获取游戏时长 */
	getAppUsageDuration: (packageName, beginTime, endTime) => {
		let res = metaXApi.callMetaX('getAppUsageDuration', '', packageName, beginTime.toString(), endTime.toString()); //获取app一段时间内的使用时长
		if (res.code == 200) {
			window.GamePlayTime(packageName, res.data);
		}
	},
	/* 是否有查看app使用时长权限 */
	hasAppUsagePermission: () => {
		let res = metaXApi.callMetaX('hasAppUsagePermission', '');
		if (res.code == 200 && res.data) {
			return true;
		} else {
			return false;
		}
	},
	/* 请求查看app使用时长权限 */
	requestAppUsagePermission: () => {
		metaXApi.callMetaX('requestAppUsagePermission', '');
	},
	/* 获取233版本号 */
	getAppVersionCode: () => {
		let res = metaXApi.callMetaX('getAppVersionCode', '');
		if (res.code == 200) { //"code":200成功,"code":404不支持的方法,"code":500异常方法,"code":302异步,
			return res.data;
		} else {
			return null;
		}
	},
	/* 获取233版本名称 */
	getAppVersionName: () => {
		let res = metaXApi.callMetaX('getAppVersionName', '');
		if (res.code == 200) { //"code":200成功,"code":404不支持的方法,"code":500异常方法,"code":302异步,
			return res.data;
		} else {
			return null;
		}
	},
	/* 获取233渠道名 */
	getAppChannel: () => {
		let res = metaXApi.callMetaX('getAppChannel', '');
		if (res.code == 200) { //"code":200成功,"code":404不支持的方法,"code":500异常方法,"code":302异步,
			return res.data;
		} else {
			return null;
		}
	},
	/* 播放广告 */
	playADVideo: () => {
		metaXApi.callMetaX('playADVideo', '', '731');
	},
	/* 后退 */
	goBack: () => {
		metaXApi.callMetaX('goBack', '');
	},
	/* 关闭页面 */
	closeActivity: () => {
		metaXApi.callMetaX('closeActivity', '');
	},
	/* 跳转web-url */
	openNativeWeb: (title, param) => {
		metaXApi.callMetaX('openNativeWeb', '', param, title);
	},
	/* 设置是否展示原⽣顶栏 */
	setNativeTitleShow: (isShow) => {
		metaXApi.callMetaX('setNativeTitleShow', '', isShow);
	},
	/* 获取底层参数 */
	getBaseParams: () => {
		let res = metaXApi.callMetaX('getBaseParams', '');
		if (res.code == 200) { //"code":200成功,"code":404不支持的方法,"code":500异常方法,"code":302异步,
			return res.data;
		} else {
			return null;
		}
	},
	/* 分享业务页面获取承接信息 */
	obtainInfo: () => {
		let res = metaXApi.callMetaX('obtainInfo', '');
		if (res.code == 200) { //"code":200成功,"code":404不支持的方法,"code":500异常方法,"code":302异步,
			return res.data;
		} else {
			return null;
		}
	}
}

if (typeof Android != 'undefined') { //运行环境为233小游戏
	primaryApi = androidApi;
} else if (typeof MetaX != 'undefined') { //运行环境为233乐园
	primaryApi = metaXApi;
}
export default primaryApi